module.exports = __webpack_public_path__ + "img/gofo.35d003f9.svg";